window.quickCartEnabled = true;

let buttonInitialized = false;

function setupQuickCartButton() {
  if (buttonInitialized) return;
  
  var button = document.querySelector('.quick-cart__submit');
  if (!button) return;

  button.type = 'button';

  button.removeEventListener('click', quickCartClickHandler); // если где-то хранится ссылка
  button.addEventListener('click', quickCartClickHandler);

  buttonInitialized = true;
}

function quickCartClickHandler(event) {
  event.preventDefault();
  window.location.href = '/cart?goto=accordion-1';
}

document.addEventListener('DOMContentLoaded', function() {
  setupQuickCartButton();

  var cartContainer = document.querySelector('.quick-cart__form') || document.querySelector('.quick-cart');
  if (!cartContainer) return;

  var observer = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
      if (mutation.type === 'childList') {
        buttonInitialized = false; // сбрасываем флаг перед новым setup
        setupQuickCartButton();
      }
    });
  });
  
  // подписываемся на любые добавления или удаления элементов внутри корзины и всех её вложенных элементов
  observer.observe(cartContainer, { childList: true, subtree: true }); 
});